<div class="delete-citations-dialog">
  <span class="close-btn-container">
    <button
      class="mat-icon-button close-icon"
      (click)="closeDeleteCitationDialog()"
    >
      <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
        >close</mat-icon
      >
    </button>
  </span>
  <ng-container *ngIf="toggleDescription; else unnumberedRefDesc">
    <div class="delete-references-dialog-content">
      <h1 class="heading delete-references-heading">
        {{ 'APP.CITATIONS.DELETE_REFERENCE_DIALOG_TITLE' | translate }}
      </h1>
      <ng-container *ngIf="isMultipleRefsDeletion; else isSingleRefDeletion">
        <div class="delete-references-title">
          <p>
            {{ 'APP.CITATIONS.DELETE_MULTIPLE_REFERENCES_DIALOG_DESC' |
            translate | citationcount:multipleRefsToDelete }}
          </p>
          <div class="multiple-references-desc">
            <p
              class="references-desc"
              *ngFor="let references of multipleRefsToDelete"
            >
              {{
              'APP.CITATIONS.DELETE_REFERENCE_DIALOG_MULTIPLE_CITED_CITATIONS' |
              translate | multiplerefs:references }}
            </p>
          </div>
        </div>
      </ng-container>
      <ng-template #isSingleRefDeletion>
        <div class="delete-references-title">
          <p>{{ 'APP.CITATIONS.DELETE_REFERENCE_DIALOG_DESC' | translate }}</p>
          <p>
            {{ 'APP.CITATIONS.DELETE_REFERENCE_DIALOG_TOTAL_CITED_CITATIONS' |
            translate | citationcount:totalCitedCount }}
          </p>
        </div>
      </ng-template>
    </div>
  </ng-container>
  <ng-template #unnumberedRefDesc>
    <div class="delete-unnumbered_references-dialog-content">
      <h1 class="heading">
        {{ 'APP.CITATIONS.DELETE_UNNUMBERED_REFERENCE_DIALOG_TITLE' | translate
        }}
      </h1>
      <p class="delete-citations-title">
        {{ 'APP.CITATIONS.DELETE_UNNUMBERED_REFERENCE_DIALOG_DESC' | translate
        }}
      </p>
    </div>
  </ng-template>
  <div class="delete-dialog-actions">
    <button
      type="button"
      class="wk-button wk-button-text"
      (click)="closeDeleteCitationDialog()"
    >
      {{ 'APP.CITATIONS.CANCEL' | translate }}
    </button>
    <button type="button" class="wk-button wk-button-danger">
      {{ 'APP.CITATIONS.DELETE' | translate }}
    </button>
  </div>
</div>
